'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NextButton = function NextButton() {
  return null;
};

NextButton.displayName = 'NextButton';

exports.default = NextButton;